import React, { forwardRef } from "react";
import { MapPin, CalendarHeart, Heart } from "lucide-react";

// Kartu kenangan cantik siap unduh & bagi ke media sosial.
const MemoryShareCard = forwardRef(function MemoryShareCard({ booking, coupleName }, ref) {
  const mem = booking.memory || {};
  const rating = mem.rating || 5;
  const photo = mem.photo || booking.img;
  const dateLabel = new Date(booking.date || booking.createdAt).toLocaleDateString("id-ID", {
    day: "numeric", month: "long", year: "numeric",
  });

  return (
    <div
      ref={ref}
      data-testid="memory-share-card"
      style={{ width: 360, background: "#fff", fontFamily: "'Plus Jakarta Sans', sans-serif" }}
      className="overflow-hidden rounded-[28px]"
    >
      {/* photo */}
      <div className="relative" style={{ height: 420 }}>
        <img src={photo} crossOrigin="anonymous" alt={booking.destName}
          className="h-full w-full object-cover" style={{ display: "block" }} />
        <div style={{ background: "linear-gradient(to top, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.15) 45%, rgba(0,0,0,0) 70%)" }}
          className="absolute inset-0" />

        {/* couple badge */}
        <div className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full px-3 py-1.5"
          style={{ background: "rgba(255,255,255,0.92)" }}>
          <Heart className="h-3.5 w-3.5" style={{ color: "#ff5a5f", fill: "#ff5a5f" }} />
          <span style={{ color: "#c9566b", fontSize: 12, fontWeight: 800 }}>{coupleName}</span>
        </div>
        {/* brand */}
        <div className="absolute right-4 top-4 rounded-full px-3 py-1.5"
          style={{ background: "linear-gradient(135deg,#ff6b4a,#ff5a5f)" }}>
          <span style={{ color: "#fff", fontSize: 12, fontWeight: 900, letterSpacing: 0.2 }}>KencanKita</span>
        </div>

        {/* bottom info */}
        <div className="absolute inset-x-0 bottom-0 p-5" style={{ color: "#fff" }}>
          <div style={{ color: "#ffd36b", fontSize: 18, letterSpacing: 2 }}>{"★".repeat(rating)}{"☆".repeat(5 - rating)}</div>
          <div style={{ fontSize: 24, fontWeight: 900, lineHeight: 1.1, marginTop: 4 }}>{booking.destName}</div>
          <div className="mt-1 flex items-center gap-1" style={{ fontSize: 13, opacity: 0.92 }}>
            <MapPin className="h-3.5 w-3.5" style={{ color: "#ffb0a0" }} /> {booking.area}, {booking.city}
          </div>
        </div>
      </div>

      {/* note + date footer */}
      <div style={{ background: "#fff" }} className="px-5 pb-5 pt-4">
        {mem.note ? (
          <p style={{ color: "#4b3f38", fontSize: 14, lineHeight: 1.5, fontStyle: "italic" }}>“{mem.note}”</p>
        ) : (
          <p style={{ color: "#a89f98", fontSize: 14 }}>Kenangan kencan kami yang berkesan.</p>
        )}
        <div className="mt-3 flex items-center justify-between border-t pt-3" style={{ borderColor: "#f0e9e2" }}>
          <div className="flex items-center gap-1.5" style={{ color: "#8a8278", fontSize: 12, fontWeight: 700 }}>
            <CalendarHeart className="h-4 w-4" style={{ color: "#ff5a5f" }} /> {dateLabel}
          </div>
          <div style={{ color: "#c9a86a", fontSize: 11, fontWeight: 800 }}>#KencanKita 💕</div>
        </div>
      </div>
    </div>
  );
});

export default MemoryShareCard;
